import axios from 'axios';
import vue from 'vue'
import {
    storage, encrypt
} from '../../utils/tools'

import Core from "@/libs/src/core";

import jsCookie from 'js-cookie';

import router from 'vue-router'

const ERROR_CODE_ABORT = 'abort'
const $key = 'kjhjas234hvbhv4h2v42sfadKJHKHS'
const pending = []
const CancelToken = axios.CancelToken
// 缓存数据过期时间
const timeout = Number(localStorage.getItem('timeout') || 0)

const removePending = ever => {
    for (const p in pending) {
        if (pending[p].id === ever.url) {
            if (ever._couldCancelRepeatRequest === true) {
                pending[p].cancel({
                    code: ERROR_CODE_ABORT,
                    msg: '取消:' + pending[p].url
                })
            }
            pending.splice(p, 1)
        }
    }
}
axios.interceptors.request.use(
    requestConfig => {
        removePending(requestConfig)
        requestConfig.cancelToken = new CancelToken(c => {
            pending.push({
                id: requestConfig.url,
                url: requestConfig.url,
                cancel: c
            })
        })
        const token = jsCookie.get('token') || Core.getProvider('Auth').proc.data.token;
        if (token) {
            requestConfig.headers.Authorization = 'Bearer ' + token
        }

        return requestConfig
    },
    error => {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    response => {
        removePending(response.config)
        return response
    },
    error => {
        console.log(error)
        if (error.response.status === 401) {
            console.warn('该请求无操作权限');

            // if (!confirm('当前无操作权限，是否重新登陆')) return Promise.reject(error);
            let Auth = Core.getProvider('Auth')
            if (!Auth.redirectURL) {
                Auth.redirectURL = location.hash.substring(1);
            }

            location.replace('#/login');
        }
        return Promise.reject(error)
    }
)

// 数据缓存
const cache = {
    set(url, val) {
        const token = $key
        let obj = {
            token: token,
            data: val,
            time: Date.now()
        }
        const str = JSON.stringify(obj)

        const enData = encrypt.encrypt(str, token)
        const bb = new Blob([enData], { type: "text/plain" })
        storage.setItem(url, bb)
    },
    async get(url) {
        const data = await storage.getItem(url)
        if (!data) return null;
        let text = await data.text()
        const token = $key
        if (!text) return null;
        text = encrypt.decrypt(text, token)
        let obj = null
        try {
            obj = JSON.parse(text || '{}')
        } catch (error) {
            return null
        }

        if (obj.token !== token || (Date.now() - obj.time) > 1000 * 60 * 60 * 24) {
            storage.removeItem(url);
            return null;
        }

        if (Object.prototype.toString.call(data) === '[object Blob]') {
            return text ? obj.data : {}
        }
        return null;
    }
}


const get = async (url, data, options = {cache: false}, param = { cache: false }) => {
    // json转为url参数
    let params = ''

    let caches = options.cache || param.cache

    if (data) {
        for (let key in data) {
            params += key + '=' + data[key] + '&'
        }
        params = params.substring(0, params.length - 1)
    }

    // if (params) {
    //     url += '?' + params
    // }

    options.params = data

    if (!caches) {
        return await axios.get(url, options)
    }
    let key = encrypt.encrypt(JSON.stringify(data || '{}') + url, 'hexu')
    let _data = await cache.get(key)
    if (_data) {
        return Promise.resolve(_data)
    }
    let res = await axios.get(url, options)
    cache.set(key, res)
    return res;
    // return axios.get(url, options)
}

const post = (url, data) => {
    return axios.post(url, data)
}

const del = (url, options = {}) => {
    return axios.delete(url, options)
};

const put = (url, options = {}) => {
    return axios.put(url, options)
};

export {
    get,
    post,
    del, put
}